<template>


<div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title">Compila il Kyc - {{userId}}</h3>
        <br/>


      </div>
      <div class="panel-body">
            <div id="veriff-root"></div>
      </div>
    </div>



</template>

<script>
import Veriff from "@veriff/js-sdk";
//var user=this.$store.state.storeUid;
// Qui devo passare il codice utente dello user + una chiave
let uu;

export default {
  name: "Kyc",
  data: function() {
    return {
      userId: this.$store.state.storeUid
    };
  }
};
</script>





<style>
</style>



// WEBPACK FOOTER //
// src/components/Kyc.vue